import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ComparisonTable() {
  const prefersReducedMotion = useReducedMotion();
  const features = [{
    name: 'Pages',
    bronze: 'Up to 5 pages',
    silver: 'Up to 10 pages',
    gold: 'Up to 15 pages'
  }, {
    name: 'SEO Level',
    bronze: 'Basic SEO',
    silver: 'SEO setup',
    gold: 'Advanced SEO'
  }, {
    name: 'Business Emails',
    bronze: '1 email',
    silver: '3 emails',
    gold: '5 emails'
  }, {
    name: 'Branding',
    bronze: 'Basic branding',
    silver: 'Branding + favicon',
    gold: 'Logo + trust badges'
  }, {
    name: 'Trust Logos',
    bronze: false,
    silver: false,
    gold: true
  }, {
    name: 'Payment Links',
    bronze: false,
    silver: false,
    gold: true
  }, {
    name: 'Content Writing',
    bronze: '£50/page add-on',
    silver: '£50/page add-on',
    gold: 'All pages included'
  }, {
    name: 'Analytics',
    bronze: false,
    silver: false,
    gold: 'GA + GSC setup'
  }, {
    name: 'Support',
    bronze: '14 days',
    silver: '30 days',
    gold: '60 days'
  }];
  return <motion.div initial={{
    opacity: 0,
    height: 0
  }} animate={{
    opacity: 1,
    height: 'auto'
  }} exit={{
    opacity: 0,
    height: 0
  }} transition={{
    duration: prefersReducedMotion ? 0.01 : 0.4,
    ease: 'easeInOut'
  }} className="mt-8 overflow-x-auto" style={{
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
  }} data-id="element-1127">
      <div className="inline-block min-w-full align-middle" data-id="element-1128">
        <table className="min-w-full bg-white dark:bg-[#1E1E1E] rounded-lg overflow-hidden border border-[#D7E0E7] dark:border-gray-700" data-id="element-1129">
          <thead className="bg-[#212C34]" data-id="element-1130">
            <tr data-id="element-1131">
              <th className="py-4 px-6 text-left font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" scope="col" data-id="element-1132">
                Feature
              </th>
              <th className="py-4 px-6 text-center font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" scope="col" style={{
              backgroundColor: 'rgba(234, 247, 250, 0.1)'
            }} data-id="element-1133">
                Bronze (£399)
              </th>
              <th className="py-4 px-6 text-center font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" scope="col" style={{
              backgroundColor: 'rgba(234, 247, 250, 0.15)'
            }} data-id="element-1134">
                Silver (£599)
              </th>
              <th className="py-4 px-6 text-center font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" scope="col" style={{
              backgroundColor: 'rgba(255, 246, 229, 0.1)'
            }} data-id="element-1135">
                Gold (£899)
              </th>
            </tr>
          </thead>
          <tbody data-id="element-1136">
            {features.map((feature, index) => <tr key={index} className="transition-colors duration-200 hover:bg-[#E8F8FB] dark:hover:bg-gray-800/50" style={{
            backgroundColor: index % 2 === 0 ? '#F9FAFB' : '#EDF1F3'
          }} data-id="element-1137">
                <th scope="row" className="py-4 px-6 border-b border-[#D7E0E7] dark:border-gray-700 font-semibold text-left text-gray-900 dark:text-gray-100" data-id="element-1138">
                  {feature.name}
                </th>
                <td className="py-4 px-6 text-center border-b border-[#D7E0E7] dark:border-gray-700" style={{
              backgroundColor: 'rgba(234, 247, 250, 0.3)'
            }} data-id="element-1139">
                  {typeof feature.bronze === 'boolean' ? feature.bronze ? <CheckIcon size={20} className="text-green-500 mx-auto" aria-label="Included" data-id="element-1140" /> : <XIcon size={20} className="text-gray-400 mx-auto" aria-label="Not included" data-id="element-1141" /> : <span className="text-gray-700 dark:text-gray-300 font-medium" data-id="element-1142">
                      {feature.bronze}
                    </span>}
                </td>
                <td className="py-4 px-6 text-center border-b border-[#D7E0E7] dark:border-gray-700" style={{
              backgroundColor: 'rgba(234, 247, 250, 0.5)'
            }} data-id="element-1143">
                  {typeof feature.silver === 'boolean' ? feature.silver ? <CheckIcon size={20} className="text-green-500 mx-auto" aria-label="Included" data-id="element-1144" /> : <XIcon size={20} className="text-gray-400 mx-auto" aria-label="Not included" data-id="element-1145" /> : <span className="text-gray-700 dark:text-gray-300 font-medium" data-id="element-1146">
                      {feature.silver}
                    </span>}
                </td>
                <td className="py-4 px-6 text-center border-b border-[#D7E0E7] dark:border-gray-700" style={{
              backgroundColor: 'rgba(255, 246, 229, 0.4)'
            }} data-id="element-1147">
                  {typeof feature.gold === 'boolean' ? feature.gold ? <CheckIcon size={20} className="text-green-500 mx-auto" aria-label="Included" data-id="element-1148" /> : <XIcon size={20} className="text-gray-400 mx-auto" aria-label="Not included" data-id="element-1149" /> : <span className="text-gray-700 dark:text-gray-300 font-medium" data-id="element-1150">
                      {feature.gold}
                    </span>}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </motion.div>;
}